import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertExperiencePageComponent from './advertExperiencePage.component';

let advertExperiencePageModule = angular.module('advertExperiencePage', [
  uiRouter
])

.component('advertExperiencePage', advertExperiencePageComponent)

.name;

export default advertExperiencePageModule;
